import uuidv4 from 'uuid/v4';
import { Image, StyleSheet, Text, TextInput, View } from '../base_components';
import BusyComponent from '../busy_component';

import UserCurrencyStore from '../../stores/user_currency_store';
import CryptoStore from '../../stores/crypto_store';
import EthTools from '../../tools/eth_tools';
import util from '../../tools/util';

import CloseButton from '../buttons/close_button';
import WideButton from '../buttons/wide_button';
import ModalDialog from '../dialogs/modal_dialog';

declare var React: any;

const styles = StyleSheet.create({
  cryptoInOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.95)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  close: {
    position: 'absolute',
    top: '1em',
    right: '1em',
    height: '3em',
    width: '3em',
  },
  balanceWrapper: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  balanceLabel: {
    color: 'white',
    fontSize: '1.4em',
  },
  balanceLine: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '3em',
    height: '3em',
  },
  coinText: {
    marginLeft: '0.4em',
    marginTop: '0.6em',
    color: 'white',
    fontSize: '2.5em',
  },
  titleText: {
    marginLeft: '2em',
    marginRight: '2em',
    marginBottom: '1em',
    maxWidth: '30em',
    color: 'white',
    fontSize: '1em',
    textAlign: 'center',
  },
  stepWrapper: {
    width: '30em',
    marginBottom: '2em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  stepText: {
    marginTop: '1em',
    color: 'white',
    fontSize: '1em',
  },
  subText: {
    margin: '2em',
    maxWidth: '30em',
    color: 'white',
    fontSize: '1em',
    textAlign: 'center',
  },
  feeText: {
    marginTop: '1em',
    color: 'white',
    fontSize: '1em',
  },
  button: {
    marginTop: '1em',
  },
  input: {
    backgroundColor: '#333',
    width: '28em',
    height: '3.5em',
    paddingLeft: '1em',
    paddingRight: '1em',
    marginBottom: '1em',
    borderRadius: '0.5em',
    color: 'white',
    fontSize: '1em',
    fontFamily: 'monospace',
  },
});

type Props = {
  onDone: () => void;
};
type State = {
  dank_coin_balance: number;
  dest_addr: string;
  amount: string;
};

const FEE = 1000;
const MIN_XFER = 1000;
const COIN_IMG = require('../../assets/img/dank_coin.gif');

export default class CryptoOutOverlay extends BusyComponent<Props, State> {
  state = {
    dest_addr: '',
    dank_coin_balance: UserCurrencyStore.getBalance('dank_coin') || 0,
    amount: '',
  };
  idempotent_key = uuidv4();
  componentDidMount() {
    UserCurrencyStore.addChangeListener(this._onCurrencyUpdate);
    UserCurrencyStore.fetchCurrency('dank_coin');
    this._onCurrencyUpdate();
    this.setBusy();
    EthTools.load(() => {
      this.clearBusy();
    });
  }
  componentWillUnmount() {
    UserCurrencyStore.addChangeListener(this._onCurrencyUpdate);
  }
  _onCurrencyUpdate = () => {
    const dank_coin_balance = UserCurrencyStore.getBalance('dank_coin') || 0;
    this.setState({ dank_coin_balance });
  };
  _onSendPress = () => {
    const { dank_coin_balance } = this.state;
    const { idempotent_key } = this;
    const dest_addr = this.state.dest_addr.trim();
    const amount = parseInt(this.state.amount);
    if (!amount || amount < MIN_XFER) {
      ModalDialog.error('You must transfer at least 1000 Dank Coin.');
    } else if (amount + FEE > dank_coin_balance) {
      ModalDialog.error('Insuficent funds.  Go earn more Dank Coin!');
    } else if (!EthTools.isAddress(dest_addr)) {
      ModalDialog.error(
        'That destination address looks invalid.  Please check it again.'
      );
    } else {
      const addr = `${dest_addr.substring(0, 21)}\u200b${dest_addr.substring(
        21
      )}`;
      const prompt = `Send ${amount} Dank Coin to ${addr} with a 1000 Dank Coin fee?`;
      ModalDialog.confirm(prompt, result => {
        if (result && this.setBusy()) {
          CryptoStore.sendCoins({ idempotent_key, dest_addr, amount }, err => {
            this.clearBusy();
            if (err) {
              ModalDialog.error('Failed to send coins, please try again.');
            } else {
              ModalDialog.alert('Coins sent');
              this.idempotent_key = uuidv4();
            }
          });
        }
      });
    }
  };

  render() {
    const { onDone } = this.props;
    const { dest_addr, dank_coin_balance } = this.state;

    return (
      <View style={styles.cryptoInOverlay}>
        <View style={styles.balanceWrapper}>
          <Text style={styles.balanceLabel}>Your Balance:</Text>
          <View style={styles.balanceLine}>
            <Image style={styles.icon} resizeMode='contain' source={COIN_IMG} />
            <Text style={styles.coinText}>
              {util.doubleToString(dank_coin_balance)}
            </Text>
          </View>
        </View>
        <Text style={styles.titleText}>
          Transfer Dank Coin from your DankCoin.net account to you Crypto Wallet
          in 3 easy steps.
        </Text>
        <View style={styles.stepWrapper}>
          <Text style={styles.stepText}>1. Enter your amount</Text>
          <Text style={styles.stepText}>2. Enter your Wallet address</Text>
          <Text style={styles.stepText}>3. Profit!</Text>
        </View>
        <TextInput
          style={styles.input}
          placeholder='Dank Coin Amount'
          autoCompleteType='off'
          autoCapitalize='none'
          autoCorrect={false}
          keyboardType='number-pad'
          onChangeText={amount => this.setState({ amount })}
          value={this.state.amount}
        />
        <TextInput
          style={styles.input}
          placeholder='Eth Wallet Address'
          autoCompleteType='off'
          autoCapitalize='none'
          autoCorrect={false}
          onChangeText={dest_addr => this.setState({ dest_addr })}
          value={this.state.dest_addr}
        />
        <Text style={styles.feeText}>Fee: {FEE} Dank Coin</Text>
        <WideButton
          style={styles.button}
          text='Send Dank Coin'
          onPress={this._onSendPress}
        />
        <Text style={styles.subText}>
          Note: Outgoing transfers can take up to 10 minutes to show up in your
          Crypto Wallet balance.
        </Text>
        <CloseButton style={styles.close} onPress={onDone} />
        <BusyComponent.BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
